import { API_BASE_URL } from '../config';
import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export default function RegistroCliente() {
    const navigate = useNavigate();
    const { loteId, documento } = useParams();
    const [formData, setFormData] = useState({
        nombre_razon_social_cliente: '',
        nro_documento_cliente: documento,
        telefono_movil_cliente: '',
        direccion_cliente: ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            //const response = await fetch(`http://192.168.0.3:3001/api/clientes`, {
			const response = await fetch(`${API_BASE_URL}/api/clientes`, {
			    method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData)
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || 'Error al registrar cliente');
            }

            alert('Cliente registrado exitosamente');
            navigate(-1);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
		<div className="max-w-2xl mx-auto p-4">
			<div className="bg-white rounded-lg shadow-md p-6">
				<div className="flex justify-between items-center mb-6">
					<h2 className="text-2xl font-bold">Registro de Cliente Nuevo</h2>
					<button 
						onClick={() => navigate(-1)}
						className="px-4 py-2 text-sm bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200"
					>
						Volver
					</button>
				</div>

				<form onSubmit={handleSubmit} className="space-y-4">
					<div>
						<label className="block text-sm font-medium text-gray-700 mb-1">
							Nombre y Apellido *
						</label>
						<input
							type="text"
							name="nombre_razon_social_cliente"
							value={formData.nombre_razon_social_cliente}
							onChange={(e) => setFormData({...formData, nombre_razon_social_cliente: e.target.value})}
							required
							className="w-full p-2 border border-gray-300 rounded-md"
						/>
					</div>

					<div>
						<label className="block text-sm font-medium text-gray-700 mb-1">
							Número de Documento
						</label>
						<input
							type="text"
							value={formData.nro_documento_cliente}
							readOnly
							className="w-full p-2 border border-gray-300 rounded-md bg-gray-50"
						/>
					</div>

					<div>
						<label className="block text-sm font-medium text-gray-700 mb-1">
							Teléfono Móvil *
						</label>
						<input
							type="text"
							name="telefono_movil_cliente"
							value={formData.telefono_movil_cliente}
							onChange={(e) => setFormData({...formData, telefono_movil_cliente: e.target.value})}
							required
							className="w-full p-2 border border-gray-300 rounded-md"
						/>
					</div>

					<div>
						<label className="block text-sm font-medium text-gray-700 mb-1">
							Dirección *
						</label>
						<input
							type="text"
							name="direccion_cliente"
							value={formData.direccion_cliente}
							onChange={(e) => setFormData({...formData, direccion_cliente: e.target.value})}
							required
							className="w-full p-2 border border-gray-300 rounded-md"
						/>
					</div>

					<div className="mt-6">
						<button
							type="submit"
							disabled={loading}
							className="w-full bg-blue-600 text-white py-3 px-4 rounded-md hover:bg-blue-700 disabled:bg-gray-300 transition-colors"
						>
							{loading ? 'Registrando...' : 'Registrar Cliente'}
						</button>
					</div>
				</form>
			</div>
		</div>
	);
}